//Swiper settings
const swiper = new Swiper('.swiper', {
	loop: false,
	slidesPerView: 1.2,
	spaceBetween: 10,
	breakpoints: {
		750: {
			slidesPerView: 2.3,
			spaceBetween: 10
			},
		970: {
			slidesPerView: 3.3,
			spaceBetween: 10
		},
		1224: {
			slidesPerView: 4.3,
			spaceBetween: 20
		}
	},
	navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
	}
})

